import React, { useState } from 'react';
import { Table } from '../ui-kit';
import { IconSquareCheck, IconSquareOpen } from '../ui-kit/icons';
import { formatTime } from '../../utils/time';
import AvailabilityCodeIcon from '../general/AvailabilityCodeIcon';
import styled from 'styled-components';
import DutyFunctionIcon from '../general/DutyFunctionIcon';
import moment from 'moment';

const TextButton = styled.div`
  cursor: pointer;
`;

const TemplatePatternDetails = ({ pattern, expand }) => {
  const [showIntervalDetails, setShhowIntervalDetails] = useState(expand);
  const toggleDetails = () => setShhowIntervalDetails(!showIntervalDetails);
  let mapDaysToNumbers = {};

  const { recurring_interval_schedule } = pattern;
  let schedule_intervals = recurring_interval_schedule.schedule_intervals;
  schedule_intervals = schedule_intervals || [];

  if (pattern.align_to_start === false) {
    const numberOfDays = moment(recurring_interval_schedule.end_time).diff(
      recurring_interval_schedule.start_time,
      'days'
    );
    for (let i = 0; i <= numberOfDays; i++) {
      mapDaysToNumbers[moment(recurring_interval_schedule.start_time).add(i, 'days').dayOfYear()] = i;
    }
  }

  return (
    <>
      {schedule_intervals.filter(interval => interval.available || interval.availability_code).length}{' '}
      {I18n.t('intervals')} {I18n.t('from')} {formatTime(recurring_interval_schedule.start_time)} {I18n.t('to')}{' '}
      {formatTime(recurring_interval_schedule.end_time)}.{' '}
      <div>
        {I18n.t(`schedules.standby_duty_template_patterns.${pattern.align_to_start ? 'aligned' : 'unaligned'}`)}
      </div>
      <div>
        {pattern.availability_codes.length > 0 &&
          I18n.t('schedules.standby_duty_template_patterns.availability_codes.carry_over')}{' '}
        {pattern.availability_codes.map(code => (
          <>
            <AvailabilityCodeIcon code={code} key={code.id} />{' '}
          </>
        ))}
      </div>
      <br />
      {showIntervalDetails ? (
        <React.Fragment>
          <Table condensed striped bordered>
            <thead>
              <tr>
                <th>{I18n.t('attributes.start_time')}</th>
                <th>{I18n.t('attributes.end_time')}</th>
                <th>{I18n.t('schedules.standby_duty.short_name')}</th>
                <th>{I18n.t('activerecord.models.schedule/availability_code.one')}</th>
              </tr>
            </thead>
            <tbody>
              {schedule_intervals
                .filter(interval => interval.available || interval.availability_code)
                .map(interval => (
                  <IntervalDetail
                    key={interval.start_time}
                    interval={interval}
                    aligned={pattern.align_to_start}
                    mapDaysToNumbers={mapDaysToNumbers}
                  />
                ))}
            </tbody>
          </Table>
          {expand ? null : (
            <TextButton>
              <strong onClick={() => toggleDetails()}>{I18n.t('close')}</strong>
            </TextButton>
          )}
        </React.Fragment>
      ) : (
        <TextButton>
          <strong onClick={() => toggleDetails()}>{I18n.t('more_details')}</strong>
        </TextButton>
      )}
    </>
  );
};

const IntervalDetail = ({ interval, aligned, mapDaysToNumbers }) => {
  const selectFormat = time => {
    if (aligned) return formatTime(time);
    return `${I18n.t('day_name')} ${mapDaysToNumbers[moment(time).dayOfYear()]} -
            ${moment(time).format('HH:mm')}`;
  };

  return (
    <tr>
      <td>{selectFormat(interval.start_time)}</td>
      <td>{selectFormat(interval.end_time)}</td>
      <td>
        {interval.standby_duty ? <IconSquareCheck /> : <IconSquareOpen />}{' '}
        {interval.assigned_functions.map(f => (
          <DutyFunctionIcon key={f.id} dutyFunction={f} />
        ))}
      </td>
      <td>{interval.availability_code && <AvailabilityCodeIcon code={interval.availability_code} />}</td>
    </tr>
  );
};
export default TemplatePatternDetails;
